import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function AvarageProductsSellFilter({
  currentPage,
  totalPages,
  setCurrentPage,
  productFilter,
  setProductFilter,
  itemsPerPage,
  setItemsPerPage,
  filteredData,
  totalCount,
  products,
  sortType,
  setSortType,
  isVisible,
  setIsVisible,
  productType,
  setProductType,
  showAVG,
  setShowAVG,
  getData = () => {},
  setShowMedian,
  showMedian,
  productRank,
  setProductRank,
  chartType = "monthly",
  title = "Sprzedaż (produkty)",
}) {
  const sortLabels = {
    1: "↓ Suma",
    2: "↓ Średnia",
    3: "↓ Nazwa",
    4: "↑ Suma",
    5: "↑ Średnia",
    6: "↑ Nazwa",
  };

  const ToggleVisibility = (
    <div className="d-flex align-items-center">
      <div
        onClick={() => {
          setIsVisible((prev) => !prev);
        }}
      >
        <div>
          <i
            className={`fas fa-toggle-${
              !isVisible ? `off text-secondary ` : `on text-primary`
            } fa-lg`}
          />
        </div>
      </div>
      <div
        className="h6 mb-0 ml-2 w-100 d-flex justify-content-center"
        style={{ fontSize: ".8rem" }}
      >
        {title}
      </div>
    </div>
  );
  return isVisible ? (
    <div className="mt-3">
      <div className="row align-items-center">
        <div className="col-lg-6 col-md-6 col-sm-12 mb-2 d-flex justify-content-around">
          {/* <div className="d-flex justify-content-between align-items-center"> */}
          {/* <div className="input-group mr-2">
              <input
                type="text"
                id="machineFilter"
                className="form-control w-50"
                placeholder="Produkt"
                value={productFilter}
                list="products"
                onFocus={() => setProductFilter("")}
                onChange={(e) => setProductFilter(e.target.value)}
                autoComplete="false"
              />
              <datalist id="products">
                {products && Array.from(products).map((machine, idx) => (
                  <option value={machine} key={idx} />
                ))}
              </datalist>
            </div> */}
          <div className="d-flex justify-content-center align-items-center mr-2">
            <div className="mr-2 form-check">
              <input
                className="form-check-input justify-content-center a1lign-items-center"
                type="radio"
                name={`productType-average-product-sale-${chartType}`}
                id={`productTypeAll-average-product-sale-${chartType}`}
                value=""
                checked={!productType}
                onChange={() => setProductType(null)}
              />
              <label
                className="form-check-label"
                htmlFor="productTypeAll-average-product-sale"
              >
                Razem
              </label>
            </div>
            <div className="mr-2 form-check">
              <input
                className="form-check-input justify-content-center a1lign-items-center"
                type="radio"
                name={`productType-average-product-sale-${chartType}`}
                id={`productTypeCard-average-product-sale-${chartType}`}
                value="1"
                checked={productType == 1}
                onChange={() => setProductType(1)}
              />
              <label
                className="form-check-label"
                htmlFor="productTypeCard-average-product-sale"
              >
                Snack
              </label>
            </div>
            <div className="mr-2 form-check">
              <input
                className="form-check-input justify-content-center a1lign-items-center"
                type="radio"
                name={`productType-average-product-sale-${chartType}`}
                id={`productTypeCash-average-product-sale-${chartType}`}
                value="2"
                checked={productType == 2}
                onChange={() => setProductType(2)}
              />
              <label
                className="form-check-label"
                htmlFor="productTypeCash-average-product-sale"
              >
                Kawa
              </label>
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <div className="mr-2 form-check">
              <input
                className="form-check-input justify-content-center a1lign-items-center"
                type="radio"
                name={`productRank-filter-${chartType}`}
                id={`productRankAll-${chartType}`}
                value="all"
                checked={productRank === "all"}
                onChange={() => setProductRank("all")}
              />
              <label className="form-check-label" htmlFor={`productRankAll-${chartType}`}>
                Wszystkie
              </label>
            </div>
            <OverlayTrigger overlay={<Tooltip>Najlepsze 50</Tooltip>}>
              <div className="mr-2 form-check">
                <input
                  className="form-check-input justify-content-center a1lign-items-center"
                  type="radio"
                  name={`productRank-filter-${chartType}`}
                  id={`productRankBest-${chartType}`}
                  value="best"
                  checked={productRank === "best"}
                  onChange={() => setProductRank("best")}
                />
                <label className="form-check-label" htmlFor={`productRankBest-${chartType}`}>
                  Najlepsze
                </label>
              </div>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>Najgorsze 50</Tooltip>}>
              <div className="mr-2 form-check">
                <input
                  className="form-check-input justify-content-center a1lign-items-center"
                  type="radio"
                  name={`productRank-filter-${chartType}`}
                  id={`productRankWorst-${chartType}`}
                  value="worst"
                  checked={productRank === "worst"}
                  onChange={() => setProductRank("worst")}
                />
                <label className="form-check-label" htmlFor={`productRankWorst-${chartType}`}>
                  Najgorsze
                </label>
              </div>
            </OverlayTrigger>
          </div>
        </div>

        <div className="col-lg-6 col-md-12 col-sm-12 mb-2">
          <div className="d-flex justify-content-end align-items-center">
            {/* <div className="d-flex align-items-center">
            <label htmlFor="itemsPerPage" className="mr-2 mb-0">
                Pokaż:
              </label>
              <select
                id="itemsPerPage"
                className="form-control form-control-sm mr-2"
                style={{ width: "70px" }}
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
          </div> */}
            <div className="d-flex align-items-center pl-2">
              <button
                className="card btn-sm mr-2"
                style={{
                  backgroundColor: "#FF7A00",
                  color: "white",
                  height: "2rem",
                }}
                onClick={() => setShowAVG(!showAVG)}
              >
                {showAVG ? "Ukryj" : "Pokaż"} średnią
              </button>
              <button
                className="card btn-sm mr-2"
                style={{
                  backgroundColor: "#666A71",
                  color: "white",
                  height: "2rem",
                }}
                onClick={() => setShowMedian(!showMedian)}
              >
                {showMedian ? "Ukryj" : "Pokaż"} medianę
              </button>
              <button
                className="card btn-sm fas fa-redo mr-2"
                style={{
                  backgroundColor: "#0140BE",
                  color: "white",
                  height: "2rem",
                }}
                onClick={getData}
              ></button>
              <label htmlFor="sortBy" className="mr-2 mb-0">
                Sortuj:
              </label>
              <select
                id="sortBy"
                className="form-control form-control-sm mr-2"
                style={{ width: "110px" }}
                value={sortType}
                onChange={(e) => {
                  setSortType(+e.target.value);
                }}
              >
                {Object.entries(sortLabels).map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
            {/* <div>
                <span>
                  {totalCount} produktów
                </span>
              </div> */}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="d-flex w-100 justify-content-start align-items-center">
      {ToggleVisibility}
    </div>
  );
}
